import { createAction, Action } from 'redux-actions';

export const actionTypes = {
  SELECT_CLINIC_MANAGER: 'SELECT_CLINIC_MANAGER',
  DEFAULT_STATE: 'DEFAULT_STATE"',
};

export const selectClinic: (
  clinicName: string,
  clincId: string,
) => Action<{ clinicName: string }> = createAction(
  actionTypes.SELECT_CLINIC_MANAGER,
  (
    clinicName: string,
    clinicId: string,
  ): { clinicName: string; clinicId: string } => ({
    clinicName,
    clinicId,
  }),
);

export const resetState: () => Action<void> = createAction(
  actionTypes.DEFAULT_STATE,
);
